import 'whatwg-fetch';
import { logEvent } from '@javascripts/util/eventLogging';

const matchStatusChange = () => {
  const { value } = document.getElementById('status-select');
  const submitButtons = document.querySelectorAll('.match-update-submit');

  submitButtons.forEach((button) => {
    const submitButtonContainer = button.parentElement;

    if (value !== '') {
      button.disabled = false; //eslint-disable-line
      submitButtonContainer.classList.remove('gray');
    } else {
      button.disabled = true; //eslint-disable-line
      submitButtonContainer.classList.add('gray');
    }
  });
};

const disableButtons = (buttons, disabledState) => {
  for (let i = 0; i < buttons.length; i += 1) {
    // eslint-disable-next-line no-param-reassign
    buttons[i].disabled = disabledState;
  }
};

const matchDeclineStatusChange = () => {
  const { value } = document.getElementById('decline-status-select');
  const submitButtons = document.getElementsByClassName('matching-decline-referral');
  const textArea = document.querySelector('#decline-text-area #message');

  if (value === 'Other' && textArea.value !== '') {
    disableButtons(submitButtons, true);
  } else if (value !== 'Other' && value !== '') {
    disableButtons(submitButtons, false);
  } else {
    disableButtons(submitButtons, true);
  }
};

const addMatchDeclineTextAreaChange = () => {
  const select = document.getElementById('decline-status-select');
  const submitButtons = document.getElementsByClassName('matching-decline-referral');
  const textArea = document.querySelector('#decline-text-area #message');

  if (textArea) {
    textArea.addEventListener('keyup', (e) => {
      const { value } = e.currentTarget;

      if (select && select.value === 'Other' && value !== '') {
        disableButtons(submitButtons, false);
      } else {
        disableButtons(submitButtons, true);
      }
    });
  }
};

const trackClickToCall = (matchId) => {
  fetch(`/matches/${matchId}/track_click_to_call`, {
    method: 'POST',
    mode: 'no-cors',
    credentials: 'include',
  });
};

const clickToCall = () => {
  const clickToCallButton = document.getElementById('click-to-call');
  const updateUsButton = document.getElementById('click-to-call-update-us');

  if (clickToCallButton.className.includes('inverse')) {
    logEvent('click_to_call_unhighlighted');
  } else {
    logEvent('click_to_call_highlighted');
  }
  clickToCallButton.classList.add('inverse');
  updateUsButton.classList.remove('inverse');

  const matchId = document.getElementById('match-info').getAttribute('data-match-id');
  trackClickToCall(matchId);
};

const clickToCallLink = () => {
  const matchId = document.getElementById('match-info').getAttribute('data-match-id');
  trackClickToCall(matchId);
};

const accept = () => {
  logEvent('match_accepted');
};

const decline = () => {
  logEvent('match_declined');
};

const toggleComments = () => {
  const expander = document.getElementById('expander');
  const truncated = document.getElementById('comments-truncated');
  const expanded = document.getElementById('comments-expanded');
  const { nodeValue } = expander.firstChild;

  truncated.classList.toggle('hidden');
  expanded.classList.toggle('hidden');

  expander.firstChild.nodeValue = nodeValue === '...View More'
    ? 'View Less'
    : '...View More';
};

const showMoreListing = () => {
  const truncated = document.getElementById('listings-truncated');
  const expanded = document.getElementById('listings-expanded');
  truncated.classList.toggle('hidden');
  expanded.classList.toggle('hidden');
};

const toggleBlackoutReasonTextArea = (event) => {
  const blackoutReasonField = document.getElementById('blackout-reason-field');
  if (blackoutReasonField) {
    blackoutReasonField.classList.toggle('hidden', event.target.value === '');
  }
};

const applyShowDeclineTextArea = () => {
  const dropdown = document.getElementById('decline-status-select');
  const textAreaContainer = document.getElementById('decline-text-area');

  if (dropdown) {
    dropdown.addEventListener('change', (e) => {
      const { value } = e.currentTarget;

      if (textAreaContainer) {
        textAreaContainer.classList.toggle('hidden', value !== 'Other');
      }
    });
  }
};

export {
  matchStatusChange,
  matchDeclineStatusChange,
  clickToCall,
  clickToCallLink,
  accept,
  decline,
  toggleComments,
  showMoreListing,
  toggleBlackoutReasonTextArea,
  applyShowDeclineTextArea,
  addMatchDeclineTextAreaChange,
};
